module.exports = __webpack_public_path__ + "static/media/12_andinvainthedreamer.22105d99.jpg";